import { render, staticRenderFns } from "./initialConfigurations.vue?vue&type=template&id=0911bd56&"
import script from "./initialConfigurations.vue?vue&type=script&lang=js&"
export * from "./initialConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports